import React from "react";
import {
  DeviceMobileSpeaker,
  Envelope,
  WhatsappLogo,
  LinkedinLogo,
  TiktokLogo,
  YoutubeLogo,
  FacebookLogo,
} from "@phosphor-icons/react";
const Contact = () => {
  return (
    <div className="text-white text-lg">
      <p className="font-bold text-xl uppercase mb-2">Contact us</p>
      <a
        className="flex items-center gap-x-2 mb-2 group"
        href="https://wa.me/+97143439358"
        target="_blank"
        rel="noreferrer"
      >
        <span className="bg-white text-black p-1 rounded-full text-lg">
          <DeviceMobileSpeaker />
        </span>
        <p className="group-hover:underline">+971 4 343 9358</p>
      </a>
      <a
        className="flex items-center gap-x-2 group"
        href="mailto:sales@martinpro-me.com"
        target="_blank"
        rel="noreferrer"
      >
        <span className="bg-white text-black p-1 rounded-full text-lg">
          <Envelope />
        </span>
        <p className="group-hover:underline">sales@martinpro-me.com</p>
      </a>

      <div className="mt-8">
        <p className="font-bold text-xl uppercase mb-2">Stay connecetd</p>

        <div className="flex items-center gap-x-3">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/MartinProfessionalMiddleEast/"
            className="bg-[#808080] transition ease-in duration-300 hover:bg-[#b8b8b8] p-1 rounded-full text-xl"
          >
            <FacebookLogo />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.youtube.com/channel/UCkLYcWRXEm2W-5QZa1pVDPw"
            className="bg-[#808080] transition ease-in duration-300 hover:bg-[#b8b8b8] p-1 rounded-full text-xl"
          >
            <YoutubeLogo />
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/company/martin-professional-middle-east/"
            className="bg-[#808080] transition ease-in duration-300 hover:bg-[#b8b8b8] p-1 rounded-full text-xl"
          >
            <LinkedinLogo />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.tiktok.com/@martinprofessional.me?is_from_webapp=1&sender_device=pc"
            className="bg-[#808080] transition ease-in duration-300 hover:bg-[#b8b8b8] p-1 rounded-full text-xl"
          >
            <TiktokLogo />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://wa.me/+97143468556"
            className="bg-[#808080] transition ease-in duration-300 hover:bg-[#b8b8b8] p-1 rounded-full text-xl"
          >
            <WhatsappLogo />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
